import { Injectable } from '@angular/core';
import { EntityService } from '../../../../rest/entity.service';
import { JQueryHTTPClient } from '../../../../rest/JQueryHTTPClient';
import { Rest_logistics } from './rest_client_logistics';
import { Rest } from '../../../../rest/rest_client';
import { Rest_task } from '../../administration/services/rest_client_task';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { AuthenticationService } from '../../../../core/services/authentication/authentication.service';
import { NotificationsService, Severity } from '../../../../services/notifications-service/notifications.service';
import Customer = Rest_logistics.Customer;


@Injectable()
export class CustomerService extends EntityService<Customer> {
    client: Rest.RestApplicationClient;
    // private _customername: Rest_logistics.Customer | null;

    constructor(
        private jquery: JQueryHTTPClient,
        private http: HttpClient,
        private auth: AuthenticationService,
        private notificationsService: NotificationsService,
    ) {
        super();
        this.client_task = new Rest_logistics.RestApplicationClient(jquery);
    }


    public getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest_logistics.Customer>> {
        return this.client_task.Customer_getPage(arg0);
    }

    find(
        arg0: string,
        queryParams?: { id?: number }
    ): Rest.RestResponse<Rest_logistics.Customer> {
        return this.client_task.Customer_find(arg0, queryParams);
    }


    create(arg0: Customer): Rest.RestResponse<Customer> {
        return this.client_task.Customer_create(arg0);
    }

    delete(arg0: Customer[]): Rest.RestResponse<void> {
        return this.client_task.Customer_delete(arg0[0]);
    }

    update(arg0: Customer): Rest.RestResponse<Customer> {
        return this.client_task.Customer_update(arg0);
    }
    updatePlanAssignments(arg0: Customer): Rest.RestResponse<Customer> {
        return this.client_task.Customer_updatePlanAssignments(arg0);
    }
    

    changeStatus(
        arg0: number[], 
        queryParams?: { status?: boolean; }
    ): Rest.RestResponse<void> {
        return this.client_task.Customer_changeStatus(arg0, queryParams);
    }

    createCustomerValiseCode(customerValiseCode: Rest_logistics.CustomerValiseCode): Rest.RestResponse<Rest_logistics.CustomerValiseCode> {
        return this.client_task.CustomerValiseCode_Create(customerValiseCode);
    }
    //valise codes
    changeStatusCustomerValiseCode(customerValiseCode: Rest_logistics.CustomerValiseCode): Promise<number> {
        return this.client_task.CustomerValiseCode_changeStatus(customerValiseCode);
        /*
        return this.http.delete(
            environment.webApiBaseUrl + 'api/task/packages/delete',
            { body: orderPackage },
        ).toPromise()
            .then(() => {
                return true;
            })
            .catch((error) => {
                this.notificationsService.add(Severity.error, 'Error', error.message);
                return false;
            }); */
    }

    //customer pickup assig auto
    createAndUpdateCustomerPickupAssigAuto(customerPickupAssigAuto: Rest_logistics.CustomerPickupAssigAuto): Rest.RestResponse<Rest_logistics.CustomerPickupAssigAuto> {
        return this.client_task.CustomerPickupAssigAuto_CreateAndUpdate(customerPickupAssigAuto);
    }

    deleteCustomerPickupAssigAuto(customerPickupAssigAuto: Rest_logistics.CustomerPickupAssigAuto): Rest.RestResponse<Rest_logistics.CustomerPickupAssigAuto> {
        return this.client_task.CustomerPickupAssigAuto_Delete(customerPickupAssigAuto);
    }

    /*
    updateCustomerPickupAssigAuto(customerPickupAssigAuto: Rest_logistics.CustomerPickupAssigAuto): Rest.RestResponse< Rest_logistics.CustomerPickupAssigAuto> {
        return this.client_task.CustomerPickupAssigAuto_Update(customerPickupAssigAuto);
    } */

    //customer pickup assig auto
    createAndUpdateCustomerRoute(customerRoute: Rest_logistics.CustomerRoute): Rest.RestResponse<Rest.GenericResp<Rest_logistics.CustomerRoute>> {
        return this.client_task.CustomerRoute_CreateAndUpdate(customerRoute);
    }
    deleteCustomerRoute(customerRoute: Rest_logistics.CustomerRoute): Rest.RestResponse<Rest_logistics.CustomerRoute> {
        return this.client_task.CustomerRoute_Delete(customerRoute);
    }

    Customer_getRoutesInter(arg0: Rest.ListPaginationRequest, typeparam: number): Rest.RestResponse<Rest.Page<Rest_logistics.Customer>> {
        let queryParams = {
            type: typeparam
        };
        return this.client_task.Customer_getRoutesInter(arg0, queryParams);
    }


    public regularCustomer(customer: Rest_logistics.Customer): Rest.RestResponse<boolean> {
        // let queryParams = {
        //     customername: null
        // };
        // if (this.customername) {
        //     queryParams.customername = this.customername
        // } 
        // return this.client_task.Customer_regularCustomer(arg0,this.customername);
        return this.client_task.Customer_regularCustomer(customer);
    }







    //    public getPageAndFilters(
    //         arg0: Rest.ListPaginationRequest
    //     ): Rest.RestResponse<Rest.ListPageAndFilters<Rest_logistics.Customer>> {
    //         return this.client_task.Customer_getPageAndFilters(arg0);
    //     }
}
